import React from 'react';

interface Props {
  icon: React.ReactNode;
  children: React.ReactNode;
  onClick?: () => void;
}

const WorkingLayerMenuItem: React.FC<Props> = ({ icon, children, onClick }) => (
  <button
    className="flex w-full cursor-pointer items-center justify-between py-4 px-4 hover:bg-gray-100"
    onClick={onClick}
  >
    <div className="flex w-full gap-3">
      {icon}
      <div className="flex flex-grow text-sm text-gray-600">{children}</div>
    </div>
  </button>
);

export default WorkingLayerMenuItem;
